RivalIQ.apps.Dashboard.module('widgets.table', function (table, App, Backbone, Marionette, $, _) {

    'use strict';

    const MetricTableValue = RivalIQ.views.ItemView.extend({
        getTemplate: function () {
            const me = this;

            if (me.model.getType() === RivalIQ.enums.dataType.STRING) {
                return '#metricLayoutStringMetricTemplate';
            }

            return '#metricLayoutNumericMetricTemplate';
        },
        className: 'metric-row',

        ui: {
            information: '.fa-info-circle',
            tooltip: '[data-toggle="tooltip"]'
        },

        onRenderLoaded: function () {
            const me = this;
            me.ui.information.popover();
            me.ui.tooltip.tooltip();
        },

        serializeData: function () {
            const me = this;

            let submetrics = me.model.get('submetrics');

            if (submetrics) {
                submetrics = submetrics.reject(function (submetric) {
                    return submetric.get('omit');
                });
            }

            return {
                index: me._index,
                metric: me.model,
                submetrics: submetrics
            };
        }
    });

    const MetricCheckbox = MetricTableValue.extend({
        getTemplate: function () {
            return '#metricLayoutMetricCheckboxTemplate';
        },

        behaviors: {
            AttributeBuilder: {}
        },

        serializeData: function () {
            const me = this;
            const data = MetricTableValue.prototype.serializeData.call(me);

            data.selected = Boolean(_.find(me.options.selected, _.partial(_.isEqual, me.model.toType())));
            if (data.submetrics) {
                data.subSelected = _.map(data.submetrics, function (metric) {
                    return Boolean(_.find(me.options.selected, _.partial(_.isEqual, metric.toType())));
                });
            }

            return data;
        }
    });

    table.MetricDisplay = RivalIQ.views.LayoutView.extend({
        template: '#tableMetricDisplayTemplate',

        regions: {
            metricLayout: '.x-metric-layout',
            upsellRegion: '.x-upsell-region'
        },

        behaviors: {
            AttributeBuilder: {},
            FormValidator: {
                bindModel: false
            }
        },

        ui: {
            modal: '.modal',
            saveBtn: '.x-save',
            information: '.fa-info-circle'
        },

        loadData: function () {
            const me = this;

            const metric = me.getOption('metric');

            const rawChildren = metric.getChildMetrics(me.options);
            const childMetrics = new RivalIQ.collections.MetricDefinitions(rawChildren.reject(function (metric) {
                return (_.result(metric.attributes, ['selectable']) === false);
            }));

            return childMetrics.fetch().done(function (metrics) {
                me.collection = metrics;
            });
        },

        onRenderLoaded: function () {
            const me = this;

            const redactEngagementLift = _.get(me, ['options', 'metric', 'attributes', 'redactEngagementLift']);
            const View = Marionette.CollectionView.extend({
                childView: MetricTableValue,
                className: 'metric-layout',
                filter: function (metric) {
                    if (redactEngagementLift) {
                        return metric.get('property') !== 'engagement_rate_by_presence_reach_lift';
                    }
                    return true;
                }
            });

            me.metricLayout.show(new View({
                collection: me.collection
            }));

            // NOTE only show the estimated impressions upsell for channels that have estimated impressions
            const channel = me.collection.at(0).get('channel');
            const channelHasEstimatedImpressions = (channel === 'facebook' || channel === 'instagram');
            if (channelHasEstimatedImpressions && me.options?.enableUpsell) {
                me.upsellRegion.show(new table.Upsell());
            }
        }
    });

    table.Upsell = RivalIQ.views.LayoutView.extend({

        template: '#metricUpsellViewTemplate',

        ui: {
            upsell: '.x-upsell',
            upsellLink: '.x-upsell-action',
            dismissButton: '.x-dismiss-upsell'
        },

        events: {
            'click @ui.upsellLink': 'onUpsellClick',
            'click @ui.dismissButton': 'onDismissClick'
        },

        onUpsellClick: function () {
            const isTrial = RivalIQ.state.account.isTrialerWithTrialPlan();
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ClickedEstimatedImpressionsUpsell, {
                isTrial: isTrial
            });
        },

        onDismissClick: function () {
            const me = this;
            me.ui.upsell.hide();
            RivalIQ.state.user.set('estimatedImpressionsUpsellDismissed', true);
        },

        templateHelpers: function () {
            const shouldUpsell = !RivalIQ.state.plan.get('has_estimated_impressions') &&
                !RivalIQ.state.user.get('estimatedImpressionsUpsellDismissed');
            const isTrialPlan = RivalIQ.state.account.isTrialerWithTrialPlan();

            const articleUrl = 'https://help.rivaliq.com/en/articles/6610816-estimated-impressions-for-competitors-on-dec-8-2022';

            return {
                shouldUpsell: shouldUpsell,
                isTrialPlan: isTrialPlan,
                articleUrl: articleUrl
            };
        }
    });

    table.ColumnPicker = table.MetricDisplay.extend({
        template: '#tableColumnPickerTemplate',

        events: {
            'click @ui.saveBtn': 'onSave'
        },

        onRenderLoaded: function () {
            const me = this;

            const metric = me.getOption('metric');

            const metrics = me.model.metricsCollection.invoke('toType');
            const selected = RivalIQ.models.MetricDefinition.buildMetric(metric, metrics).invoke('toType');

            const View = Marionette.CollectionView.extend({
                childView: MetricCheckbox,
                childViewOptions: {
                    selected: selected
                },
                className: 'metric-layout'
            });

            me.metricLayout.show(new View({
                collection: me.collection
            }));
        },

        onSave: function () {
            const me = this;

            me.ui.saveBtn.button('Loading');

            // recompute me.formAttrs to make sure we have the latest state of the form.
            me.triggerMethod('resetFormAttributes');

            const metrics = _.map(me.formAttrs.metrics, function (definitionStr) {
                return JSON.parse(definitionStr);
            });

            me.model.save({
                metrics: metrics
            })
                .done(function () {
                    me.ui.modal.modal('hide');
                    me.triggerMethod('save:complete');
                })
                .fail(function () {
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        }
    });
});
